import exodusInstance from 'lib/api/instances/exodus';
import { APIResponse } from '../../../../@types/api-response';
import portfolioEndpoint from '../constants/apiEndpoints/portfolio';
import { VirtualPortfolio, VirtualPortfolioList } from '../types/api/portfolio';

const { defaultInstance } = exodusInstance;

export const getPortfolioDetail = (
  symbol: string,
): Promise<APIResponse<VirtualPortfolio>> =>
  defaultInstance.get(portfolioEndpoint.detail(symbol));

export const getPortfolioList = (): Promise<
  APIResponse<VirtualPortfolioList>
> => defaultInstance.get(portfolioEndpoint.list());
